import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { Header, Icon } from 'semantic-ui-react';
import { useStore } from '../../stores/store';
import '../MediaQuery/responsive-photo-crop.css';
import { userLanguage } from '../userLanguageSchema/userLanguage';
interface Props {
  setFiles: (files: any) => void;
  photouploadalign?: boolean;
}

export default function PhotoWidgetDropzone({
  setFiles,
  photouploadalign,
}: Props) {
  const dzStyles = {
    border: 'dashed 3px #eee',
    borderColor: '#eee',
    borderRadius: '5px',
    paddingTop: '20px',
    paddingLeft: '160px',
    height: 200,
  };

  const photoStyles = {
    border: 'dashed 3px #eee',
    borderColor: '#eee',
    borderRadius: '5px',
    height: '200px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const dzActive = {
    borderColor: 'green',
  };

  const onDrop = useCallback(
    (acceptedFiles: any[]) => {
      setFiles(
        acceptedFiles.map((file: any) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          }),
        ),
      );
    },
    [setFiles],
  );
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
  });
  const { commonStore } = useStore();

  return (
    <div
      {...getRootProps()}
      style={
        photouploadalign
          ? photoStyles
          : isDragActive
            ? { ...dzStyles, ...dzActive }
            : dzStyles
      }
    >
      <input {...getInputProps()} />
      <Icon name="upload" size="huge" />
      <Header
        className="dropimgstyle"
        content={
          (userLanguage[0].UploadProfilePhoto?.UPPL01 as any)?.[
            `${commonStore.language.key}`
          ]
        } //'Drop image here'
      />
    </div>
  );
}
